import AmexGDAB2BWhyWeLove from './AmexGDAB2BWhyWeLove';

export default AmexGDAB2BWhyWeLove;
